import { Dress } from '../../../components/vectors/advantages/Dress';
import { Bags } from '../../../components/vectors/advantages/Bags';
import { Mask } from '../../../components/vectors/advantages/Mask';
import { Shoes } from '../../../components/vectors/advantages/Shoes';
import { Champagne } from '../../../components/vectors/advantages/Champagne';
import { useTranslation } from 'react-i18next';

export const useGetAdvantagesData = () => {
    const { t } = useTranslation();
    return [
        {
            name: t('advantages.ownAtelierAndDesigner'),
            icon: Dress(),
        },
        {
            name: t('advantages.availableForEventsWorldwide'),
            icon: Bags(),
        },
        {
            name: t('advantages.allPerformancesAreDoneInMasks'),
            icon: Mask(),
        },
        {
            name: t('advantages.exclusiveChoreography'),
            icon: Shoes(),
        },
        {
            name: t('advantages.openToCreatingCustomShows'),
            icon: Champagne(),
        },
    ];
};
